module.exports = __webpack_public_path__ + "static/media/paginate-first.4acb788b.svg";